import {$, w} from './constants';
import './cookies';
import './scroll-bar';
import './video';
import './woocommerce-helper';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
	var url= window.location.href; 
	if ((url.indexOf("?") > -1)){
		 //Cuando cargue la página, obtenemos la url creando un objeto search params 
		 let search_params = new URLSearchParams(window.location.search);
		 //Sólo si existe el parámetro store, se muestra el div 
		 if(search_params.has('reset-link-sent')){
			console.log('Página de recuperación');
			$('#page-title').addClass('helper-woo');
		 }
	}
});

$(document).ready(function() {
	console.log('Hello world from El Cultivo! --Ready');

	ScrollTrigger.matchMedia({
		// desktop
		"(min-width: 1201px)": function() {
			console.log('Desktop')
			$('.button--search').click(function(){
				$('.input--search').toggleClass('show');
				$('.header__search-mobile-aside').toggleClass('show');
				if($('.header').attr('data-state') === "close"){
					$('.input--search').addClass('white');
				}else{
					$('.input--search').removeClass('white');
				}
			});
			
			$(window).scroll(function (event) {
				let scroll = $(window).scrollTop();
				let header = $('.header').offset().top;
				if($('.header').attr('data-state') === "open"){

					if(scroll >= header){
						$('#open-menu').toggleClass('close');
						$('.header-black').toggleClass('red');
						$('.header-red').toggleClass('red');
						$('.svg--logo').toggleClass('red');
						$('.header__aside').toggleClass('show');
						$('.header').data('state', 'close');
						$('.header').attr('data-state', 'close');
						$('.input--search').removeClass('show');
						$('.input--search-mobile').toggleClass('white');
						$('#bag-icon').toggleClass('white');
						$('.btn--search').toggleClass('white');
						$('.btn--search-mobile').toggleClass('white');
						$('.btn--search-mobile').toggleClass('black');
					}
				}else if($('.header__search-mobile').attr('data-state') === "open"){
					if(scroll >= header){
						console.log('ocultar búsqueda');
						$('.header-black').removeClass('open-search');
						$('.btn--search-mobile').addClass('white');
						$('.btn--search-mobile').removeClass('black');
						$('.input--search-mobile').removeClass('show');
						$('.header__search-mobile').data('state', 'close');
						$('.header__search-mobile').attr('data-state', 'close');
						$('.header__menu').removeClass('hide');
						$('.header').removeClass('help');
					}
				}
			});

			
			if( $('.header--shop').length < 1 ){
				$('.menu-item-has-children').hover(function() {
					$(this).children('ul.sub-menu').addClass('active');
					$('.header').data('state', 'open');
					$('.header').attr('data-state', 'open');
					$('.btn--search').addClass('white');
					$('#open-menu').toggleClass('close');
					$('.header-mask').toggleClass('red');
					$('.header-black').toggleClass('red');
					$('.header-red').toggleClass('red');
					$('.svg--logo').toggleClass('red');
					$('.input--search-mobile').toggleClass('white');
					$('.header__links').toggleClass('black');
					$('.btn--search-mobile').removeClass('white');
					$('.btn--search-mobile').addClass('black');
					$('#bag-icon').toggleClass('white');
					if($('.header__search-mobile').attr('data-state') === "open"){
						$('.header-black').removeClass('open-search');
						$('.input--search-mobile').removeClass('show');
						$('.header__search-mobile').data('state', 'close');
						$('.header__search-mobile').attr('data-state', 'close');
					}
				},function(){
					$(this).children('ul.sub-menu').removeClass('active');
					$('.header').data('state', 'close');
					$('.header').attr('data-state', 'close');
					$('#open-menu').toggleClass('close');
					$('.header-mask').toggleClass('red');
					$('.header-black').toggleClass('red');
					$('.header-red').toggleClass('red');
					$('.svg--logo').toggleClass('red');
					$('.input--search-mobile').toggleClass('white');
					$('.header__links').toggleClass('black');
					$('.btn--search-mobile').addClass('white');
					$('.btn--search-mobile').removeClass('black');
					$('#bag-icon').toggleClass('white');
				});
			}
			
		},
		// iPad
		"(max-width: 1200px)": function() {
			console.log('Móvil')
			
			$(window).scroll(function (event) {
				let scroll = $(window).scrollTop();
				let header = $('.header').offset().top;
				if($('.header').attr('data-state') === "open"){

					if(scroll >= header){
						$('#open-menu').toggleClass('close');
						$('.header-black').removeClass('red');
						$('.header-red').removeClass('red');
						$('.header-mask').removeClass('red');
						$('.header').removeClass('help');
						$('.svg--logo').toggleClass('red');
						$('.btn--search').toggleClass('white');
						$('.btn--search-mobile').toggleClass('white');
						$('.btn--search-mobile').toggleClass('black');
						$('.input--search-mobile').toggleClass('white');
						$('.header__aside').toggleClass('show');
						$('.header').data('state', 'close');
						$('.header').attr('data-state', 'close');
						$('.header__search-mobile').removeClass('active');
						$('#bag-icon').toggleClass('white');
					}
				} else if($('.header__search-mobile').attr('data-state') === "open"){
					if(scroll >= header){
						console.log('ocultar búsqueda');
						$('.header-black').removeClass('open-search');
						$('.btn--search-mobile').addClass('white');
						$('.btn--search-mobile').removeClass('black');
						$('.input--search-mobile').removeClass('show');
						$('.header__search-mobile').data('state', 'close');
						$('.header__search-mobile').attr('data-state', 'close');
						$('.header__search-mobile').removeClass('active');
						$('.header__menu').removeClass('hide');
					}
				}
			});
		},
		"(max-width: 1024px)": function() {
			$(window).scroll(function (event) {
				let scroll = $(window).scrollTop();
				let header = $('.header').offset().top;
				if($('.header').attr('data-state') === "open"){

					if(scroll >= header){
						$('#open-menu').toggleClass('close');
						$('.header-black').removeClass('red');
						$('.header-red').removeClass('red');
						$('.header-mask').removeClass('red');
						$('.header').removeClass('help');
						$('.svg--logo').toggleClass('red');
						$('.btn--search').toggleClass('white');
						$('.btn--search-mobile').toggleClass('white');
						$('.btn--search-mobile').toggleClass('black');
						$('.input--search-mobile').toggleClass('white');
						$('.header__aside').toggleClass('show');
						$('.header').data('state', 'close');
						$('.header').attr('data-state', 'close');
						$('.header__search-mobile').removeClass('active');
						$('#bag-icon').toggleClass('white');
					}
				} else if($('.header__search-mobile').attr('data-state') === "open"){
					if(scroll >= header){
						console.log('ocultar búsqueda');
						$('.header-black').removeClass('open-search');
						$('.btn--search-mobile').addClass('white');
						$('.btn--search-mobile').removeClass('black');
						$('.input--search-mobile').removeClass('show');
						$('.header__search-mobile').data('state', 'close');
						$('.header__search-mobile').attr('data-state', 'close');
						$('.header__search-mobile').removeClass('active');
						$('.header__menu').removeClass('hide');
					}
				}
			});
			$('.footer__title--la').click(function(){
				$('.footer__title--london').siblings('.footer__site-hide').removeClass('show');
				$(this).siblings('.footer__site-hide').toggleClass('show');
			});
			$('.footer__title--london').click(function(){
				$('.footer__title--la').siblings('.footer__site-hide').removeClass('show');
				$(this).siblings('.footer__site-hide').toggleClass('show');
			});
		},
		"(max-width: 650px)": function() {
			$(window).scroll(function (event) {
				let scroll = $(window).scrollTop();
				let header = $('.header').offset().top;
				if(scroll >= header ){
					$('.filter_target_dropdown_mobile').removeClass('active');
				}
			});
		},
		// all
		"all": function() {
			console.log('Todos tamaños');
			$('.header__menu').click(function(){
				if($('.header').attr('data-state') === "close"){
					console.log('change to open')
					$('.header').data('state', 'open');
					$('.header').attr('data-state', 'open');
					$('.btn--search').addClass('white');
				}else{
					$('.header').data('state', 'close');
					$('.header').attr('data-state', 'close');
				}
				if($('.header__search-mobile').attr('data-state') === "open"){
					$('.header').removeClass('black');
					$('.btn--search-mobile').removeClass('white');
					$('.btn--search-mobile').addClass('black');
					$('.input--search-mobile').removeClass('show');
					$('.header__search-mobile').data('state', 'close');
					$('.header__search-mobile').attr('data-state', 'close');
				}else{
					$('.btn--search-mobile').toggleClass('white');
					$('.btn--search-mobile').toggleClass('black');
				}
				$('#open-menu').toggleClass('close');
				$('.header-mask').toggleClass('red');
				$('.header-black').toggleClass('red');
				$('.header-red').toggleClass('red');
				$('.svg--logo').toggleClass('red');
				$('.input--search-mobile').toggleClass('white');
				$('.header__aside').toggleClass('show');
				$('.btn--search').toggleClass('white');
				$('#bag-icon').toggleClass('white');
			});

			$('.btn--search-mobile').click(function(){
				
				$(this).parent().toggleClass('active');
				$('.header').toggleClass('help');
				
				if($('.header__search-mobile').attr('data-state') === "close"){
					$('.header__search-mobile').data('state', 'open');
					$('.header__search-mobile').attr('data-state', 'open');
					$('.header__menu').addClass('hide');
				}else{
					$('.header__search-mobile').data('state', 'close');
					$('.header__search-mobile').attr('data-state', 'close');
					$('.header__menu').removeClass('hide');
				}

				if($('.header').attr('data-state') === "close"){
					$('.header-red').removeClass('red');
					$('.header-black').removeClass('red');
					$('.header-mask').removeClass('red');
					$('.input--search-mobile').toggleClass('show');
					$('.header-black').toggleClass('open-search');
					$(this).toggleClass('white');
				}else{
					$('#open-menu').toggleClass('close');
					$('.header-red').removeClass('red');
					$('.header-mask').removeClass('red');
					$('.header-black').removeClass('red');
					$('.header-black').toggleClass('open-search');
					$('.svg--logo').removeClass('red');
					$(this).removeClass('white');
					$(this).removeClass('black');
					$('.input--search-mobile').addClass('show');
					$('.header__aside').removeClass('show');
					$('.header').data('state', 'close');
					$('.header').attr('data-state', 'close');
				}
			});

			//Filtro
			$('.filter_trigger_dropdown').click(function(){
				$(this).toggleClass('active');
				$(this).siblings('.filter_target_dropdown').toggleClass('active');
			});

			$('.filter_trigger_i').click(function(){
				
				if( $(this).hasClass('active') ){
					$(this).removeClass('active');
					$(this).siblings('.filter_trigger_d').removeClass('active');
				}else{
					$('.filter_trigger_i').removeClass('active');
					$('.filter_trigger_d').removeClass('active');
					$(this).addClass('active');
					$(this).siblings('.filter_trigger_d').addClass('active');
				}
				
			});

			$('.filter_trigger_dropdown_mobile').click(function(){
				$(this).siblings('.filter_target_dropdown_mobile').addClass('active');
			});
			$('.filter_close_dropdown_mobile').click(function(){
				$(this).parent().parent().removeClass('active');
			});
			$('.filter_heading_mobile').click(function(){
				if( $(this).hasClass('active') ){
					$(this).removeClass('active');
					$(this).siblings('.filter_options_mobile').removeClass('active');
				}else{
					$('.filter_heading_mobile').removeClass('active');
					$('.filter_options_mobile').removeClass('active');
					$(this).addClass('active');
					$(this).siblings('.filter_options_mobile').addClass('active');
				}
			});

			if($('.slider__artists').length){
				$('.slider__artists').slick({
					arrows: false,
					infinite: true,
					autoplay: false,
					speed: 500,
  					fade: true,
					cssEase: 'linear',
					asNavFor: '.slider__nav-slider',
					slidesToShow: 1,
					slidesToScroll: 1,
					swipe: false,
					swipeToSlide: false,
				});
				$('.slider__nav-slider').slick({
					arrows: false,
					dots: false,
					infinite: true,
					asNavFor: '.slider__artists',
					slidesToShow: 4,
					slidesToScroll: 1,
					focusOnSelect: true,
				});
			}

			if($('.single-artist__gallery-slider').length){
				$('.single-artist__gallery-slider').slick({
					arrows: false,
					dots: true,
					dotsClass: 'slider__artists-dots',
					pauseOnDotsHover: true,
					pauseOnHover: false,
					infinite: true,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1100,
					swipe: false,
					swipeToSlide: false

				});
			}

			//Flecha home
			$('.arrow-down').click(function(){
				$('html, body').animate(
					{
					  scrollTop: $('#anchor-arrow').offset().top - 100,
					},
					1200,
					'swing'
				)
			})

			//Flecha about
			$('.arrow-page').click(function(){
				$('html, body').animate(
					{
					  scrollTop: $('#anchor-arrow').offset().top - 120,
					},
					1200,
					'swing'
				)
			})


			//Flecha archivos
			$('.arrow-archive').click(function(){
				$('html, body').animate(
					{
					  scrollTop: $('#anchor-arrow').offset().top,
					},
					1200,
					'swing'
				)
			})

			//Mostrar/Ocultar el form
			$('.show-contact-inquire').click(function(){
				$('#contact-inquire').toggleClass('show-flex');
			});

			$('.show-contact-price').click(function(){
				$('#contact-price').toggleClass('show-flex');
			});

			$('#pop-inquire').click(function(){
				$('#contact-inquire').toggleClass('show-flex');
				$('.error-form').html('');
			});

			$('#pop-price').click(function(){
				$('#contact-price').toggleClass('show-flex');
				$('.error-form').html('');
			});

			//Creamos el submit del form
			$("#contactForm, #contactFormPrice").submit(function(){

				//Detenemos el form
				event.preventDefault();

				if( $('#privacy').prop('checked') || $('#privacy-price').prop('checked')  ) {

					$.post(cltvo_js_vars.ajax_url, $(this).serializeArray())
					.done(function(response){

						alert('Thank you for contacting GALERIE ARTEMPO');
						$('input').val('');
						$('textarea').val('');
						$('checkbox').val('');
						$('#privacy').val('');
						$('#contact-inquire').removeClass('show-flex');
						$('#contact-price').removeClass('show-flex');

					}).fail(function(error) {
						$('.error-form').html(error.responseJSON.message).show();
					});
				}else{
					$('.error-form').html('You must accept the Privacy Policy to continue.').show();
				}
			});
			//Form para página de contacto
			$("#contactFormPage").submit(function(){

				//Detenemos el form
				event.preventDefault();
				$.post(cltvo_js_vars.ajax_url, $(this).serializeArray())
					.done(function(response){

						alert('Thank you for contacting GALERIE ARTEMPO');
						$('input').val('');
						$('#text-contact').val('');
						$('.error-form').html('');

					}).fail(function(error) {
						$('.error-form').html(error.responseJSON.message).show();
					});
			});

			//Form para el contacto general
			$("#subscribe-form").submit(function(){

				//Detenemos el form
				event.preventDefault();

				$.post(cltvo_js_vars.ajax_url, $(this).serializeArray())
					.done(function(response){
						
						alert('Subscribed');
						$('#mce-EMAILt').val('');

					}).fail(function(error) {
						alert("Could not connect to the registration server. Please try again later.");
					});
			});

			const red_scroll = gsap.timeline();
			const title_scroll = gsap.timeline();
			const pop_scroll = gsap.timeline();
			if($('.home__scroll-red-top').length){
				red_scroll.to('.home__scroll-red-top',{
					scrollTrigger : {
						trigger: ".home__scroll-red",
						scrub: true,
						start : "top",
						end : "bottom 50%",
						toggleActions : "restart pause resume pause",
						markers: false,
					},
					height: "0",
					ease: "none"
				});
			}
			if($('.home__artists-scroll-red').length){
				red_scroll.to('.home__artists-scroll-red',{
					scrollTrigger : {
						trigger: ".home__artists",
						scrub: true,
						start : "top-=20px 40%",
						end : "bottom 50%",
						toggleActions : "restart pause resume pause",
						markers: false,
					},
					height: "300px",
					opacity: 0,
					ease: "none",
				});
			}
			if($('#pop-up-trigger').length){
				pop_scroll.to('#pop-up-trigger',{
					scrollTrigger : {
						trigger: "#pop-up-trigger",
						scrub: true,
						start : "top +=140",
						end : "bottom 50%",
						onEnter: () =>{
							$('#pop-up-newsletter').addClass('active');
						},
						markers: false,
						once: true
					}
				});
			}
			if($('#pop-up-newsletter').length){
				if (typeof window.sessionStorage != undefined) {
					if (!sessionStorage.getItem('newsletter_pop_up')) {
						$('#pop-up-newsletter-close').click(function(){
							console.log('Close notification session storage');
							sessionStorage.setItem('newsletter_pop_up', true);
							sessionStorage.setItem('storedWhen', (new Date()).getTime());
							$('#pop-up-newsletter').addClass('hide');
						});
					}else{
						console.log('Logged in session storage')
						$('#pop-up-newsletter').addClass('hide');
					}
				}
			}

			
			$('.single-artist__bio-scroll-more').click(function(){
				$('.single-artist__bio-scroll-block').toggleClass('show');
				$('.single-artist__bio-scroll-trim').toggleClass('hide');
				$(this).toggleClass('more');
			});
			
			// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);

			if($('#arrow-for-ios').length){
				const fullScreenEnabled = !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen);
				if (!fullScreenEnabled) {
					$('#arrow-for-ios').addClass('ios');
					$('.hero__banner').addClass('fix-vh');
					$('.single-room__banner').addClass('fix-vh');
					$('.single-room__banner-text').addClass('fix-vh');
					$('.story__banner--archive').addClass('fix-vh');
					$('.story__mask--archive').addClass('fix-vh');
				}
			}
			
			if($('#page-title').length){
				title_scroll.to('#scrollable-title',{
					scrollTrigger : {
						trigger: '#page-title',
						scrub: true,
						start: "top+=10",
						end: "bottom-=95%",
						toggleActions : "restart pause resume pause",
						markers: false,
						onEnter : () =>{
							$('#scrollable-title').addClass('hide-title');
							$('.scrollable-fixer').addClass('hide');
						},
						onLeave : () =>{
							$('#scrollable-title').addClass('hide-title');
							$('.scrollable-fixer').addClass('hide');
							if( $('.filter_trigger_dropdown').length ){
								$('.filter_trigger_dropdown').removeClass('active');
								$('.filter_trigger_dropdown').siblings('.filter_target_dropdown').removeClass('active');
							}
						},
						onEnterBack : () =>{
							$('#scrollable-title').removeClass('hide-title');
							$('.scrollable-fixer').removeClass('hide');
						}
					}
				});
			}

			//Slider single product
			if($('#single-slider').length){
				$('#single-slider').slick({
					arrows: true,
					infinite: true,
					autoplay: false,
					speed: 500,
  					fade: true,
					cssEase: 'linear',
					slidesToShow: 1,
					slidesToScroll: 1,
					adaptiveHeight: true,
					prevArrow: "<div class='arrow-s arrow-s--left'>",
					nextArrow: "<div class='arrow-s arrow-s--right'>",
				});
			}
			$('#tabs-nav div:first-child').addClass('active');
			$('.tab-container').hide();
			$('.tab-container:first').show();

			$('#tabs-nav .tab').click(function(){
				$('#tabs-nav .tab').removeClass('active');
				$(this).addClass('active');
				$('.tab-container').hide();

				let index = $(this).data('tab');
				let activeTab = $('#tab-content').find(`div[data-tab="${index}"]`);
				$(activeTab).fadeIn();
				return false;
			  });

			$('.delivery-scroll-more').click(function(){
				$('.delivery-scroll-block').toggleClass('show');
				$('.delivery-scroll-trim').toggleClass('hide');
				$(this).toggleClass('more');
			});
		}

	});

	$( '.tab' ).click(function(){

		let div = $( this ).attr( 'href' ) + '-grid';
		let sibling_tab = $( this ).siblings().get(0);

		if( $( sibling_tab ).hasClass( 'current' ) ){

			$( sibling_tab ).removeClass( 'current' );
			$( this ).addClass( 'current' );
		}

		if( $( div ).hasClass( 'hidden' ) ){
			let sibling = $( div ).siblings().get(0);

			$( sibling ).addClass( 'hidden' );
			$( div ).removeClass( 'hidden' );
		}
	});



    $('#trigger_login_user').click(function(){
        $(this).addClass('current');
        $('#trigger_login_register').removeClass('current');
        $('#login_container').addClass('active');
        $('#register_container').removeClass('active');
    })
    $('#trigger_login_register').click(function(){
        $(this).addClass('current');
        $('#trigger_login_user').removeClass('current');
        $('#register_container').addClass('active');
        $('#login_container').removeClass('active');
    })

	//Cambio de posición en error login
	if ($('#login_container').length && $('ul.notice-shop-error').length) {
	  $('div.woocommerce-notices-wrapper').insertAfter('#error-target')//where you want to place 
	}
	if ($('#lost_container').length && $('ul.notice-shop-error').length) {
		$('div.woocommerce-notices-wrapper').insertAfter('#error-target')//where you want to place 
	  }

	const actualBtn = document.getElementById('documents');

    const fileChosen = document.getElementById('file-chosen');

    //Contacto
   /*  $("#contact").validate({
        rules: {
            name : {
                required: true
            },
            phone: {
                required: true,
                number: true
            },
            email: {
                required: true,
                email: true
            },
            documents: {
                accept: "pdf"
            }
        },
        errorClass : "error-contact",
        errorElement: "label",
        submitHandler: function(form) {
            event.preventDefault();
            $('#submit').prop('disabled', true);
			
            let formData = new FormData( form );
            let portfolio = document.getElementById('documents').files[0];

            formData.append('action', 'contact');
            formData.append('portfolio', portfolio);

            $.ajax({
                url: cltvo_js_vars.ajax_url,
                type: form.method,
                data: formData,
                contentType: false,
                processData: false,
                success: function(response) {
                    $('#name').val('');
                    $('#phone').val('');
                    $('#email').val('');
                    $('#documents').val('');
                    fileChosen.textContent = '  ';
                    $('#submit').prop('disabled', true);
                    $('#success').html('¡Gracias! Nos comunicaremos contigo a la brevedad');
                },
                error: function( error ){
                    $('#error').text( error.responseJSON.message );
                }
            });
        }
    }); */

    //->Fix para file personalizado

    if($(actualBtn).length){
        actualBtn.addEventListener('change', function(){
            fileChosen.textContent = this.files[0].name
        });
    }

})

window.addEventListener('resize', () => {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});
